import { useSelector } from 'react-redux';
import {Route} from 'react-router-dom'
import { Redirect } from 'react-router-dom/cjs/react-router-dom.min';
import useCheckUserAccess from '../components/custom_hooks/useCheckUserAccess';
import ComponentErrorBoundary from "../BugsnagErrorReporting.jsx";
import { Tracker, Tracker2 } from '../components/utils/mixpanel/tracker.js';
import { useEffect, Suspense } from 'react';
import { Loader } from '../design_system/components/Loader.jsx';
import { canUseAnyExport } from '../utils/access';

const ALL_LAYOUTS = ["default-layout", "feed-layout"];

const RouteRenderer = (route) => {
  const current_user = useSelector(state => state.current_user)
  const current_team = useSelector(state => state.current_team)
  const checkUserAccess = useCheckUserAccess() 
  const PROTECTION_LEVELS = {
    'LOGGED_OUT': current_user.apiKeyStatus != 'validated', 
    'LOGGED_IN': current_user.apiKeyStatus == 'validated',
    'HAS_NOT_SELECTED_TEAM' : !current_team.team?.id,
    'HAS_SELECTED_TEAM': current_team.team?.id,
    'IS_INSTITUTE_ADMIN': current_user.user?.is_super_admin || current_team.team?.is_admin,
    'IS_ADMIN': current_user.user?.is_admin,
    'IS_SUPER_ADMIN': current_user.user?.is_super_admin,
    'IS_PUBLISHER': current_user.user?.is_publisher,
    'IS_PUBLISHER_PLUS': current_user.user?.is_super_admin || current_user.user?.is_publisher
  }
  let shouldRender = true;
  (route.protection || []).forEach( protection_level => shouldRender = shouldRender && PROTECTION_LEVELS[protection_level]);
  const protectionAllowed = shouldRender;
  const authorizationAllowed = !route.checkAuthorization || checkUserAccess(route.checkAuthorization);
  shouldRender = shouldRender && authorizationAllowed;
  if(route.requiresAnyExportPermission){
    shouldRender = shouldRender && canUseAnyExport({
      team: current_team.team,
      legacyAllowed: checkUserAccess("page_data_exports")
    })
  }
  if(route.requiresMapperFeature){
    shouldRender = shouldRender && (
      current_user.user?.is_super_member === true ||
      current_team.team?.displayable_features?.display_mapper_suggestions === true
    )
  }
  if(route.requiresDirectoryFeature || route.requiresReportsFeature){
    shouldRender = shouldRender && (
      current_user.user?.is_super_member === true ||
      current_team.team?.displayable_features?.display_new_directory === true
    )
  }
  useEffect(() => {
    Tracker.init(current_user.user, current_team.team);
    Tracker2.init(current_user.user, current_team.team);
  }, [current_user.user?.id, current_team.team?.id]);

  useEffect(() => {
    if (shouldRender) {
      Tracker.startSessionRecording();
      if (route.trackPageVisit) Tracker.trackPageView({ page: route.path });
    }
  }, [route.path]);
  
  const RenderedComponent = shouldRender ? route.component :
    (protectionAllowed && !authorizationAllowed ? route.accessDeniedComponent : null);
  if(RenderedComponent) {
    return <ComponentErrorBoundary>
      <Route
      path={route.path}
      exact={route.exact}      
      render={(props) => (
        <div className={route.layout || "default-layout"}>
          <Suspense fallback={<Loader Size="Large" isLoading={true} isFullPage={true} />}>
            <RenderedComponent {...props} {...route.props} routes={route.routes} />
          </Suspense>
        </div>
      )}
      />
    </ComponentErrorBoundary>
  }
  const fallbackPath = current_team.team?.home_path || "/feed";
  return <Redirect from={route.path} to={fallbackPath}></Redirect>;
}
export default RouteRenderer
